import styles from './HamburgerIcon.module.scss';

import classNames from 'classnames';
import React from 'react';

const HamburgerIcon = (props) => (
  <button className={props.className}
       styleName={classNames('hamburger-icon', {open: props.open})}
       onClick={props.onClick}>
      <span styleName='bar'></span>
      <span styleName='bar'></span>
      <span styleName='bar'></span>
      <span styleName='bar'></span>
  </button>
);

export default HamburgerIcon;



// WEBPACK FOOTER //
// ./src/components/HamburgerIcon.js